document.addEventListener('DOMContentLoaded', function() {
    const form = document.querySelector('#GetInTouchForm');
    const submitButton = form.querySelector('button[type="submit"]');
    const successMessage = document.querySelector('.get-in-touch__message--success');
    const errorMessage = document.querySelector('.get-in-touch__message--error');
    const errorMessageText = errorMessage.querySelector('.get-in-touch__message-text');
    const messageField = document.getElementById('GetInTouch-message');
    const charCount = document.querySelector('.get-in-touch__char-count');
    
    // Character counter for message field
    messageField.addEventListener('input', function() {
        const remaining = 5000 - this.value.length;
        charCount.textContent = `${remaining} characters remaining`;
        
        if (remaining < 100) {
            charCount.classList.add('get-in-touch__char-count--warning');
        } else {
            charCount.classList.remove('get-in-touch__char-count--warning');
        }
    });
    
    // Rate limiting variables
    const RATE_LIMIT_KEY = 'celestron_contact_last_submit';
    const RATE_LIMIT_MINUTES = 2;
    
    // Check if user has submitted recently
    function checkRateLimit() {
        const lastSubmit = localStorage.getItem(RATE_LIMIT_KEY);
        if (lastSubmit) {
            const timeSinceLastSubmit = Date.now() - parseInt(lastSubmit);
            const minutesSinceLastSubmit = timeSinceLastSubmit / (1000 * 60);
            
            if (minutesSinceLastSubmit < RATE_LIMIT_MINUTES) {
                const remainingMinutes = Math.ceil(RATE_LIMIT_MINUTES - minutesSinceLastSubmit);
                return {
                    allowed: false,
                    remainingMinutes: remainingMinutes
                };
            }
        }
        return { allowed: true };
    }
    
    form.addEventListener('submit', async function(e) {
        e.preventDefault();
        
        // Hide any previous messages
        successMessage.classList.remove('visible');
        errorMessage.classList.remove('visible');
        
        // Check message length
        const message = messageField.value;
        if (message.length > 5000) {
            errorMessageText.textContent = 'Message exceeds 5000 character limit.';
            errorMessage.classList.add('visible');
            return;
        }
        
        // Check rate limit
        const rateLimitCheck = checkRateLimit();
        if (!rateLimitCheck.allowed) {
            errorMessageText.textContent = `Please wait ${rateLimitCheck.remainingMinutes} more minute(s) before submitting again.`;
            errorMessage.classList.add('visible');
            return;
        }
        
        // Disable submit button to prevent double submission
        submitButton.disabled = true;
        submitButton.textContent = 'Submitting...';
        form.classList.add('loading');
        
        // Get form data
        const formData = {
            firstName: document.getElementById('GetInTouch-first-name').value,
            lastName: document.getElementById('GetInTouch-last-name').value,
            email: document.getElementById('GetInTouch-email').value,
            inquiryType: document.getElementById('GetInTouch-inquiry-type').value,
            message: message
        };
        
        console.log('Form data being sent:', formData);
        
        try {
            // Submit to PHP endpoint - UPDATE THIS URL TO YOUR HEROKU ENDPOINT
            const response = await fetch('https://celestron-support-contact-f9a2d4afec91.herokuapp.com/get-in-touch.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData)
            });
            
            const result = await response.json();
            
            if (response.ok && result.success) {
                // Store submission timestamp for rate limiting
                localStorage.setItem(RATE_LIMIT_KEY, Date.now().toString());
                
                // Show success message
                successMessage.classList.add('visible');
                errorMessage.classList.remove('visible');
                form.reset();
                charCount.textContent = '5000 characters remaining';
                charCount.classList.remove('get-in-touch__char-count--warning');
                
                // Scroll to success message
                successMessage.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                
                // Hide success message after 5 seconds
                setTimeout(() => {
                    successMessage.classList.remove('visible');
                }, 5000);
            } else {
                throw new Error(result.message || 'Submission failed');
            }
        } catch (error) {
            // Show error message
            errorMessageText.textContent = 'There was an error submitting the form. Please try again.';
            errorMessage.classList.add('visible');
            successMessage.classList.remove('visible');
            
            // Scroll to error message
            errorMessage.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            
            console.error('Error:', error);
        } finally {
            // Re-enable submit button and remove loading state
            submitButton.disabled = false;
            submitButton.textContent = 'Submit';
            form.classList.remove('loading');
        }
    });
});